/**
 * Digital Portfolio > Languages
 */
jQuery(document).ready(function ($) {
  $(document).on("click", `[data-click="play-audio"]`, (event) => {
    const audio = $(event.currentTarget).find("audio").get(0);
    audio.play();
  });
});
